<template>
  <div class="mob-remove-table-fixed">
    <Card>
      <appoint ref="appoint"></appoint>
      <AppointAccept ref="AppointAccept"></AppointAccept>
      <search isDisplay='none' :isOperatorDisplay="false" ref="search"></search>
      <workSheetTable ref="workSheetTableRef" :tableColumns="tableColumns" :status="status"></workSheetTable>
    </Card>
    <Modal v-model="closeModal" title="关闭" @on-cancel="cancelCloseModal">
      <Form :models="closeForm" :label-width="36" ref="closeForm">
        <FormItem label="回复" prop="message">
          <Input type="textarea" v-model="closeForm.message" placeholder="回复提交人（可选）" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button :loading="closing" type="primary" @click="closeOk">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import search from './components/search'
import workSheetTable from './components/workSheetTable'
import appoint from './components/appoint'
import AppointAccept from './components/appoint-accept'
import moment from 'moment'
import { ReceiveApi, CloseApi } from '../../api/logistics/worksheet'

export default {
  name: 'no-accept',
  components: {
    'search': search,
    'workSheetTable': workSheetTable,
    'appoint': appoint,
    'AppointAccept': AppointAccept
  },
  data () {
    return {
      status: [1],
      tableColumns: [
        {
          title: '工单编号',
          align: 'center',
          width: 200,
          key: 'wsid'
        },
        {
          title: '提交人',
          align: 'center',
          width: 160,
          key: 'submitter',
          render: (h, params) => {
            if (params.row.count > 0) {
              return h('div', [
                h('span', params.row.submitter),
                h('Badge', {
                  props: {
                    count: params.row.count
                  }
                })
              ])
            }
            return h('span', params.row.submitter)
          }
        },
        {
          title: '标题',
          tooltip: true,
          minWidth: 490,
          align: 'center',
          key: 'title'
        },
        {
          title: '工单类型',
          width: 200,
          align: 'center',
          key: 'type',
          render: (h, params) => {
            let result = ''
            if (params.row.type) {
              result = params.row.type.type_name
            }
            return h('span', result)
          }
        },
        {
          title: '提交时间',
          align: 'center',
          width: 200,
          key: 'c_time',
          render: (h, params) => {
            if (params.row.c_time) {
              return h('div', moment(params.row.c_time).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '状态',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return h('span', '未受理')
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 251,
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$refs.workSheetTableRef.detail(params.row.id)
                  }
                }
              }, '详情'),
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                attrs: {
                  disabled: params.row.source === '在线客服'
                },
                on: {
                  click: () => {
                    this.$refs.appoint.show(params.row)
                  }
                }
              }, '指派'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                attrs: {
                  disabled: params.row.source === '在线客服',
                  loading: this.receiving
                },
                on: {
                  click: () => {
                    // this.receive(params.row.id)
                    this.$refs.AppointAccept.show(params.row.id, params.row.type)
                  }
                }
              }, '受理'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                attrs: {
                  disabled: params.row.source === '在线客服'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.closeForm.id = params.row.id
                    this.closeModal = true
                  }
                }
              }, '关闭')
            ])
          }
        }
      ],
      receiving: false,
      closeModal: false,
      closeForm: {
        id: '',
        message: ''
      },
      closing: false
    }
  },
  activated () {
    console.log('未受理页面激活')
    this.status = [1]
    this.$refs.search.searchSubmit()
    this.$refs.workSheetTableRef.close()
  },
  methods: {
    receive (id) {
      this.receiving = true
      ReceiveApi({ id: id }).then(res => {
        const result = res.data
        if (result.code === 200) {
          this.$Notice.success({
            title: '操作成功！'
          })
          this.$refs.workSheetTableRef.init()
        } else {
          this.$Notice.error({
            title: '操作失败',
            desc: result.msg
          })
        }
        this.receiving = false
      }).catch(_ => {
        this.receiving = false
      })
    },
    cancelCloseModal () {
      this.closeForm = {
        id: '',
        message: ''
      }
    },
    closeOk () {
      this.closing = true
      CloseApi(this.closeForm).then(res => {
        const result = res.data
        if (result.code === 200) {
          this.$Notice.success({
            title: '操作成功！'
          })
          this.$refs.workSheetTableRef.init()
          this.cancelCloseModal()
          this.closeModal = false
        } else {
          this.$Notice.error({
            title: '操作失败',
            desc: result.msg
          })
        }
        this.closing = false
      }).catch(_ => {
        this.closing = false
      })
    }
  }
}
</script>
